import { Component, Input, OnInit, OnChanges } from '@angular/core';
import { SunatReportService } from '../../../sunat-report.service';
import { TableActionsBaseTemplate } from 'src/app/@amiga-pyme/table-actions/templates/table-actions-base.template';

@Component({
  selector: 'app-step-preview',
  templateUrl: './step-preview.component.html',
  styleUrls: ['./step-preview.component.scss']
})
export class StepPreviewComponent
  extends TableActionsBaseTemplate
  implements OnInit, OnChanges {

  @Input() businessId!: number;
  @Input() period!: string;

  loading = false;
  error = false;

  private lastBusinessId: number | null = null;
  private lastPeriod: string | null = null;
  private lastRequestKey: string | null = null;
  private lastPageRequested: number | null = null;

  constructor(private sunatService: SunatReportService) {
    super();
  }

  ngOnInit(): void {
    this.initTable();
  }

  ngOnChanges(): void {
    if (!this.businessId || !this.period) return;

    const businessChanged = this.lastBusinessId !== this.businessId;
    const periodChanged = this.lastPeriod !== this.period;

    if (!businessChanged && !periodChanged) return;

    this.lastBusinessId = this.businessId;
    this.lastPeriod = this.period;
    this.lastRequestKey = null;

    this.loadPage(1, 10);
  }

  private initTable() {
    this.table.settings = {
      title: 'Vista Previa Kardex',
      filterColumns: true,
      serverSide: true,
      totalRecords: 0,
      columns: [
        { header: 'Periodo', field: 'periodo' },
        { header: 'Código establecimiento', field: 'codigo_establecimiento' },
        { header: 'Catálogo', field: 'catalogo' },
        { header: 'Tipo existencia', field: 'tipo_existencia' },
        { header: 'Código producto', field: 'codigo_producto' },
        { header: 'Fecha operación', field: 'fecha_operacion' },
        { header: 'Tipo documento', field: 'tipo_documento' },
        { header: 'Serie', field: 'serie' },
        { header: 'Número', field: 'numero' },
        { header: 'Tipo operación', field: 'tipo_operacion' },
        { header: 'Descripción', field: 'descripcion' },
        { header: 'Unidad de medida', field: 'unidad_medida' },
        { header: 'Método valuación', field: 'metodo_valuacion' },

        { header: 'Cantidad entrada', field: 'cantidad_entrada' },
        { header: 'Costo unitario entrada', field: 'costo_unitario_entrada' },
        { header: 'Costo total entrada', field: 'costo_total_entrada' },

        { header: 'Cantidad salida', field: 'cantidad_salida' },
        { header: 'Costo unitario salida', field: 'costo_unitario_salida' },
        { header: 'Costo total salida', field: 'costo_total_salida' },

        { header: 'Cantidad saldo', field: 'cantidad_saldo' },
        { header: 'Costo unitario saldo', field: 'costo_unitario_saldo' },
        { header: 'Costo total saldo', field: 'costo_total_saldo' },
        { header: 'Estado', field: 'estado' },


      ]
    };

    this.table.data = [];
    this.table.actions = [];
    this.table.actionsHead = [];
  }

  currentPage = 1;
  currentLimit = 10;

  loadPage(page: number, limit: number) {
    const key = `${page}-${limit}`;
    if (this.lastRequestKey === key) return;
    this.lastRequestKey = key;
    this.lastPageRequested = page;
    this.loading = true;
    this.error = false;

    const [month, year] = String(this.period).split('/');
    const periodo = `${year}${month.padStart(2, '0')}00`;

    this.sunatService
      .getKardexPreview(this.businessId, { page, limit, periodo })
      .subscribe({
        next: (res) => {
          const items = res.body?.data?.items ?? [];
          const total = res.body?.data?.meta?.totalItems ?? 0;

          // NO recrees settings si tu tabla resetea la paginación por eso
          this.table.settings.totalRecords = total;

          this.table.data = [...items];

          // 🔥 CLAVE: una vez cargado, ya no hay riesgo de reset
          this.lastPageRequested = null;

          this.loading = false;
        },
        error: () => {
          this.error = true;
          this.loading = false;
        }
      });
  }


  override onReciveAction(event: any) {
    if (event.action !== 'paginate') return;

    const { page, limit } = event.data;

    // 🚫 Bloquea SOLO el reset fantasma
    if (page === 1 && this.lastPageRequested && this.lastPageRequested > 1) {
      return;
    }

    this.loadPage(page, limit);
  }

}
